import { render, staticRenderFns } from "./GrupoAcessoTable.vue?vue&type=template&id=e644bfc6&scoped=true&"
import script from "./GrupoAcessoTable.vue?vue&type=script&lang=js&"
export * from "./GrupoAcessoTable.vue?vue&type=script&lang=js&"
import style0 from "./GrupoAcessoTable.vue?vue&type=style&index=0&id=e644bfc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e644bfc6",
  null
  
)

export default component.exports